import { render } from "./AmoCrm.vue?vue&type=template&id=adb6b3a2&scoped=true&ts=true"
import script from "./AmoCrm.vue?vue&type=script&lang=ts"
export * from "./AmoCrm.vue?vue&type=script&lang=ts"

import "./AmoCrm.vue?vue&type=style&index=0&id=adb6b3a2&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adb6b3a2"]])

export default __exports__